module.exports = __webpack_public_path__ + "static/media/nhalogo.0cd043e0.png";